<template>
  <div id="details-map">
    <ks-header :header-title="$t('common.map')" />

    <div id="main-container" v-scroll-lock="true">
      <div id="main-content" class="full-width h-100">
        <ks-map v-if="!loading" :institutions="[institution]" />
      </div>
    </div>
  </div>
</template>

<script>
import KsHeader from '@/components/layout/Header.vue'
import KsMap from '@/components/common/Map.vue'
import ScrollPosition from '@/mixins/scrollposition'

export default {
  name: 'DetailsMap',
  components: {
    KsMap,
    KsHeader
  },
  mixins: [ScrollPosition],
  data() {
    return {
      institution: {},
      loading: true
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    listType: {
      type: String,
      default: 'list'
    }
  },
  async activated() {
    if (!this.loading) this.loading = true
    let data = await this.$store.getters['institutions/getById'](this.id)
    if (data === undefined) {
      await this.$store.dispatch('institutions/fetchDetails', { id: this.id, locale: this.$i18n.locale })
      data = await this.$store.getters['institutions/getById'](this.id)
    }
    this.center = data.position
    this.institution = data
    this.loading = false
  }
}
</script>
